/* import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands' */

import '@fortawesome/fontawesome-free/css/all.css';

import 'accordion-js/dist/accordion.min.css';
import '@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css';
import "./scss/index.scss";
import "./js/theme";